import { Component, HostListener, OnInit, effect } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../../../core/services/users.service';
import { UserRole } from '../../../core/constants/userRole';
import { PageRoutes } from '../../../core/constants/pages-routes';
import { Router } from '@angular/router';
import { CommonFunction } from '../../../core/utils/common-utility';
import { NgxPermissionsModule } from "ngx-permissions";
import { UserAccess } from '../../../core/constants/userAccess';
import { ENVIRONMENT_LIST } from '../../../core/constants/common-enum';
import { AuthLogoutService } from '../../../core/services/auth-logout.service';
import { firstValueFrom } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-header',
  imports: [CommonModule, NgxPermissionsModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.less',
})
export class HeaderComponent {
  showProfileDropdown: boolean = false;
  userDetails: any;
  UserRole = UserRole;
  commonUtility = CommonFunction;
  UserAccess = UserAccess;
  showChangePassword = true;
  constructor(
    private modalService: NgbModal,
    private userService: UserService,
    private router: Router,
    private logoutService: AuthLogoutService,
    private toastr: ToastrService
  ) {
    effect(() => {
      const userDetails = this.userService.loggedInUserDetails();
      if (userDetails) {
        this.userDetails = userDetails;
      }
    });
  }

  onOrganisation() {
    this.router.navigate(['/', PageRoutes.PAGE, PageRoutes.SETUP, PageRoutes.ORGANIZATION, PageRoutes.VIEW, PageRoutes.GENERALINFO, this.userDetails?.organisationId])
  }

  async changePassword() {
    const { SendResetPasswordLinkComponent } = await import('../../../pages/setup/users/send-reset-password-link/send-reset-password-link.component');
    const modelRef = this.modalService.open(SendResetPasswordLinkComponent);
    modelRef.componentInstance.modelRef = modelRef;
    modelRef.componentInstance.userName = this.userDetails?.firstName + ' ' + this.userDetails?.lastName;
    modelRef.result.then(async (result) => {
      if (result) {
        const payload = {
          isAdminPasswordChange: true,
          newPassword: null,
          auth0UserId: this.userDetails?.auth0UserId
        };
        const resetLinkSent = await firstValueFrom(this.userService.updateUserPassword(payload))
        if (resetLinkSent) {
          this.toastr.success('Link Sent Successfully.')
        }
      }
    }).catch(() => { });
  }

  async onSwitchOrganization() {
   const { SwitchOrganizationComponent } = await import('../../../shared/components/switch-organization/switch-organization.component');
   const modelRef = this.modalService.open(SwitchOrganizationComponent);
   modelRef.componentInstance.modelRef = modelRef;
  }

  toggleProfileDropdown(event: MouseEvent) {
    event.stopPropagation();
    this.showProfileDropdown = !this.showProfileDropdown;
  }

  closeDropdown() {
    this.showProfileDropdown = false;
  }

  logout() {
    this.logoutService.logout();
  }

  closeProfileDropdown(): void {
    this.showProfileDropdown = false;
  }

  viewProfile() {
    this.router.navigate(['/', PageRoutes.PAGE, PageRoutes.SETUP, PageRoutes.USERS, PageRoutes.VIEW_PROFILE])
  }

  @HostListener('document:click')
  onDocumentClick(): void {
    this.closeProfileDropdown();
  }

  getEnvironmentName(statusId: any): { name: string, className: string } {
    const status = ENVIRONMENT_LIST.find(s => s.value == statusId);
    return status ? { name: status.name, className: status.statusClass } : { name: '', className: '' };
  }
}
